var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoanDefaultedInactive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 22,
    viewBox: "0 0 17 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 22H9.88372V16.4571L5 11.762L5.78698 11L11 16.0117V22Z",
    fill: "#4F4F4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 15H5V11H9V12H6V15Z",
    fill: "#4F4F4D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 22H0V4.58002L4.59 0H16V6H14V2H5.41L2 5.41V20H7V22Z",
    fill: "#4F4F4D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 7H2V5H5V2H7V7Z",
    fill: "#4F4F4D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11 10H16",
    stroke: "#4F4F4D",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11 8H16",
    stroke: "#4F4F4D",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4062 8C12.945 8 13.4616 8.2382 13.8426 8.66219C14.2235 9.08619 14.4375 9.66125 14.4375 10.2609C14.4375 10.8605 14.2235 11.4356 13.8426 11.8595C13.4616 12.2835 12.945 12.5217 12.4062 12.5217H11L14.4375 16",
    stroke: "#4F4F4D",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoanDefaultedInactive);
export default __webpack_public_path__ + "static/media/loan-defaulted-inactive.ba6c51b9ff6ede78d74e4a3cab51ce50.svg";
export { ForwardRef as ReactComponent };